var map = {
	"./dark/close.png": 8111,
	"./dark/deposit-bg.png": 5037,
	"./dark/energy-bg.png": 8055,
	"./dark/follow-bg.png": 3418,
	"./dark/header-bg.png": 8826,
	"./dark/light.png": 7103,
	"./dark/logo.png": 3270,
	"./dark/pointer-active.png": 5593,
	"./dark/redeem-bg.png": 2823,
	"./dark/redeem-input.png": 6816,
	"./dark/reward-bg.png": 4992,
	"./dark/reward-item-bg.png": 6426,
	"./dark/tabbar/home.png": 4857,
	"./dark/tabbar/promotions.png": 7178,
	"./dark/tabbar/share.png": 9923,
	"./dark/tabbar/task.png": 3711,
	"./dark/withdraw-bg.png": 5329,
	"./light/close.png": 5201,
	"./light/deposit-bg.png": 2055,
	"./light/energy-bg.png": 4497,
	"./light/follow-bg.png": 7552,
	"./light/header-bg.png": 7324,
	"./light/light.png": 7993,
	"./light/logo.png": 4892,
	"./light/pointer-active.png": 5607,
	"./light/redeem-bg.png": 5937,
	"./light/redeem-input.png": 250,
	"./light/reward-bg.png": 8978,
	"./light/reward-item-bg.png": 9920,
	"./light/tabbar/home.png": 8952,
	"./light/tabbar/promotions.png": 184,
	"./light/tabbar/share.png": 9717,
	"./light/tabbar/task.png": 9109,
	"./light/withdraw-bg.png": 6451
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8735;